export default __webpack_public_path__ + "static/media/mango.8ef21d6a.png";